import React from "react";
import "./Amenidades.scss";
import { Informacion_Amenidades } from '../../utils'
import {
  Backgroundbigcontainer,
  Containeramenidades,
  Griditem,
  Gridwrapper,
  Littleline,
  Montserrat,
  Roboto,
} from "../../Components/Styled";

const Amenidades = ({ amenidades }) => {

  const { SubTitulo } = Informacion_Amenidades;

  return (
    <Backgroundbigcontainer
      ref={amenidades}
      className="Amenidades"
      varpadding="77px 0 118px"
      varbackgroundcolor="#F5F5F5"
      varpaddingm="0px 0px 50px"
    >
      <Containeramenidades>
        <Littleline />
        <Montserrat
          varweight="600"
          fontsize="48px"
          fontsizem="22px"
          varmargin="20px auto"
        >
          Amenidades
        </Montserrat>
        <Roboto
          fontsize="22px"
          fontsizem="14px"
          varmargin="20px auto"
          varmaxwidth="433px"
        >
          {SubTitulo}{" "}
        </Roboto>

        <Gridwrapper className="imagenitem imagenes-wrapper">
          <Griditem className="imagenitem parquecentral" />
          <Griditem className="imagenitem plazacomercial" />
          <Griditem className="imagenitem colegio" />
          <Griditem className="imagenitem areaverde" />
          <Griditem className="imagenitem restaurante" />
          <Griditem className="imagenitem servicios" />
        </Gridwrapper>
      </Containeramenidades>
    </Backgroundbigcontainer>
  );
};

export default Amenidades;
